<template>
    <div class="page-warpper flex flex-direction">
        <header-menu-modular></header-menu-modular>
        <div class="container flex-sub">
            <div class="page-nav flex align-center justify-between margin-top-sm">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">当前位置：益宣宝 <span class="margin-lr-xs">></span>{{ title }}</div>
                </div>
                <div>欢迎 <b>{{ user.mnickname }}</b> ，使用益宣宝！</div>
            </div>
            <div class="page-container flex flex-sub">
                <menu-modular :navIndex="navIndex"></menu-modular>
                <div class="content-container">
                    <router-view @setIndex="getIndex(arguments)" class="content"></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <router-link to="/web/version">
            <img v-if="isNew" class="version" src="../../assets/img/icon_version.png"/>
            <img v-else class="version" src="../../assets/img/icon_version.png"/>
        </router-link>
        <help-windows></help-windows>
        <version-index-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                                     @watchState="watchState"></version-index-detail-dialog>
    </div>
</template>

<script>

import MenuModular from "@/views/web/components/MenuModular";
import HeaderMenuModular from "@/views/web/components/HeaderMenuModular";
import FooterModular from "@/views/web/components/FooterModular";
import config from '/package.json'
import HelpWindows from "@/views/web/components/HelpWindows";
import VersionIndexDetailDialog from "@/views/web/components/VersionIndexDetailDialog";
import {getInfo} from "@/api";

export default {
    name: "Home",
    components: {
        VersionIndexDetailDialog,
        HelpWindows,
        FooterModular,
        HeaderMenuModular,
        MenuModular
    },
    data() {
        return {
            navIndex: [0],
            title: '',
            menuVisible: true,
            isNew: false,
            detailDialogVisible: false,
            cur_nid: 0,
        }
    },
    created() {
        let _version = window.localStorage.getItem('version') || '1.0.0'
        this.isNew = config.version > _version
        window.localStorage.setItem('version', config.version);
        this.getUpInfo()
    },

    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        getIndex(data) {
            this.navIndex = data[0]
            this.title = data[1]
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        async getUpInfo() {
            let _data = await getInfo()
            if (_data.data.length === 1) {
                this.cur_nid = _data.data[0].id
                this.detailDialogVisible = true
            }
        },

        watchState() {
            this.detailDialogVisible = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.page-warpper {
    height: 100vh;
    background: #ebeff5;
    overflow-y: auto;

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;

        .page-nav {
            font-size: 16px;
            color: #666666;
        }

        .page-container {
            margin: 15px 0;

            .content-container {
                display: flex;
                flex-direction: column;
                width: calc(100% - 180px);
                background-color: #0a2240;
                border-radius: 10px;
                padding: 10px;
                margin-left: 10px;

                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            }
        }

    }


    .version {
        position: fixed;
        bottom: 150px;
        right: 70px;
        width: 80px;
    }
}
</style>
